// extracted by mini-css-extract-plugin
export default {"illustration":"Selfie_illustration__cQ6KW"};